import React from 'react'
import { Box, Grid, Typography } from '@mui/material';

const TechReqDetailView = ({ tech }) => {
    return (
        <Box>
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
            >
                <Grid item xs={2}>
                    <Typography variant="subtitle2" component="div" >기술지원 타입</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="body2" component="div" >{tech?.workTyp}</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="subtitle2" component="div" >희망 작업 기간</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="body2" component="div" >{tech?.workStDt}~{tech?.workEdDt}</Typography>
                </Grid>
            </Grid>
            {tech?.workTyp === '기타' && (
                <Grid
                    item
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
                >
                    <Grid item xs={2}>
                        <Typography variant="subtitle2" component="div" >기타사유</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant="body2" component="div" >{tech?.workTypDet}</Typography>
                    </Grid>
                </Grid>
            )}

            <Grid
                item
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
            >
                <Grid item xs={2}>
                    <Typography variant="subtitle2" component="div" >기술지원 요청사항</Typography>
                </Grid>
                <Grid item xs={10}>
                    <Typography sx={{ whiteSpace: 'pre-line' }} variant="body2" component="div">{tech.workTxt}</Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

export default TechReqDetailView